import { render, staticRenderFns } from "./CompareHeaderRightCTA.vue?vue&type=template&id=2ac1154b"
import script from "./CompareHeaderRightCTA.vue?vue&type=script&lang=js"
export * from "./CompareHeaderRightCTA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports